import { useEffect, useState } from 'react';

const ONE_SECOND_MS = 1000;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
export const COUNTDOWN_TICK_MS = 15 * ONE_SECOND_MS;
export const COUNTDOWN_SECONDS_TICK_MS = ONE_SECOND_MS;

export type CouponCountdown = {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
};

export const getCouponCountdown = (
	dateTime: string,
	now = Date.now()
): CouponCountdown | undefined => {
	const left = new Date(dateTime).getTime() - now;
	if (!(left > 0)) {
		return undefined;
	}
	const totalSeconds = Math.floor(left / ONE_SECOND_MS);
	return {
		days: Math.floor(totalSeconds / SECONDS_PER_DAY),
		hours: Math.floor((totalSeconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR),
		minutes: Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE),
		seconds: totalSeconds % SECONDS_PER_MINUTE,
	};
};

export const useCouponCountdown = (dateTime?: string, tickMs = COUNTDOWN_TICK_MS) => {
	const [now, setNow] = useState<number>();

	useEffect(() => {
		if (!dateTime) {
			return;
		}
		setNow(Date.now());
		const timer = setInterval(() => setNow(Date.now()), tickMs);
		return () => clearInterval(timer);
	}, [dateTime, tickMs]);

	return {
		ready: now !== undefined,
		countdown: dateTime && now !== undefined ? getCouponCountdown(dateTime, now) : undefined,
	};
};
